import { computed } from 'vue';
import { get } from 'lodash';

import { useStore } from 'vuex';
import { isUserWarehouseRestricted } from '@/helpers/permissions';

export default function useAuth() {
  const store = useStore();

  const meRef = computed(() => get(store, 'state.Auth.me'));

  const user = computed(() => meRef.value);
  const userId = computed(() => user.value?.id);

  const isWarehouseRestricted = computed(() => isUserWarehouseRestricted(user.value));

  return { meRef, user, userId, isWarehouseRestricted };
}
